import { render, staticRenderFns } from "./TranslationPage.vue?vue&type=template&id=5c7749f7&scoped=true"
import script from "./TranslationPage.vue?vue&type=script&lang=js"
export * from "./TranslationPage.vue?vue&type=script&lang=js"
import style0 from "./TranslationPage.vue?vue&type=style&index=0&id=5c7749f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7749f7",
  null
  
)

export default component.exports